import {Empty} from "antd";
import React, {useEffect} from "react";
import {useAppDispatch} from "../../hooks";
import {markQueryRead} from "./cohortBuilderSlice";
import ReportTableau from "./ReportTableau";
import UntrackableCohortMessage from "./UntrackableCohortMessage";
import {useRouteMatch} from "react-router-dom";
import {Routes} from "../../pages/routes";
import {findQuery} from "../../reducers/util";
import {Project} from "../../types/Project";

export const DescriptiveStats = ({project}: { project: Project}) => {
    const {params} = useRouteMatch(Routes.Project)
    const query = findQuery(project, params.studyId)!
    const sparkQuery = query.sparkQuery!
    const trackable = query.trackable
    const requestId = sparkQuery.requestId
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(markQueryRead(query.id))
    }, [dispatch, query.id])

    if (sparkQuery.response) {
        if (trackable) {
            return <ReportTableau key="tableau-report" cohortId={requestId} dataset={query.dataset} />
        } else {
            return <UntrackableCohortMessage />
        }
    } else {
        return <Empty/>
    }
}